const state = () => ({
  operational: true,
  nonOperational: true,
})

const actions = {
  toggleOperationalState({ commit }) {
    commit('TOGGLE_OPERATIONAL')
  },
  toggleNonOperationalState({ commit }) {
    commit('TOGGLE_NON_OPERATIONAL')
  },
  clearOperational({ commit }) {
    commit('CLEAR_OPERATIONAL')
  },
}

const mutations = {
  TOGGLE_OPERATIONAL(state) {
    state.operational = !state.operational
  },
  TOGGLE_NON_OPERATIONAL(state) {
    state.nonOperational = !state.nonOperational
  },
  CLEAR_OPERATIONAL(state) {
    state.operational = true
    state.nonOperational = true
  },
}

const getters = {
  getOperational: (state) => {
    return state.operational
  },
  getNonOperational: (state) => {
    return state.nonOperational
  },
  getOperationalParam: (state) => {
    if (state.operational && state.nonOperational) {
      return 2
    }
    if (!state.operational && !state.nonOperational) {
      return null
    }
    return state.operational ? 1 : 0
  },
  hasConditionSelected: (state) => {
    return state.operational || state.nonOperational
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
